export default function LogoPage() {
    return (
        <div className="silverfort-loader app">
            <div className="logo"></div>
        </div>
    );
}
